import wakelock from '@/utils/wakelock'

const actions = {
  requestWakeLockAction: () => {
    wakelock.requestWakeLock()
  },
  releaseWakeLockAction: () => {
    wakelock.releaseWakeLock()
  },
}

export default actions
